/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/avg.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The average of a numeric field.',
  examples: [
    'FROM employees\n| STATS AVG(height)',
    'FROM employees\n| STATS avg_salary_change = ROUND(AVG(MV_AVG(salary_change)), 10)',
    'TS exp_histo_sample\n| WHERE instance == "instance-0"\n| STATS average = ROUND(AVG(responseTime), 4)',
    'TS histogram_timeseries_index\n| WHERE instance == "instance-0"\n| STATS average = ROUND(AVG(responseTime::tdigest), 4)',
  ],
  params: {
    number: 'Expression that outputs values to average.',
  },
};

export default docs;
